module.exports = __webpack_public_path__ + "ab09cba19cd21342c07539e1c66a5c0e.svg";